import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ChairpersonLoginForm } from '@/components/auth'
import { ROUTES } from '@/constants'

export const ChairpersonLoginPage = () => {
  const navigate = useNavigate()

  const onSuccess = () => {
    navigate(ROUTES.CHAIRPERSON_DASHBOARD)
  }

  const onAccountRecovery = () => {
    navigate(ROUTES.CHAIRPERSON_ACCOUNT_RECOVERY)
  }

  return (
    <ChairpersonLoginForm
      onSuccess={onSuccess}
      onAccountRecovery={onAccountRecovery}
    />
  )
}
